import Column from '@app/components/layout/Column'
import { EventCard } from '@app/components/blocks/event/EventCard'
import { Title } from '@app/components/core/typography/Title'
import { useTranslations } from '@i18n/useLanguage'
import { ViewTopicCommunityModel } from 'functions/app/topic-community/view'
import { Text } from '@app/components/core/typography/Text'
import { pages } from '@app/util/links'

export const TopicCommunityPageEvents = ({
  topicCommunity,
}: {
  topicCommunity: ViewTopicCommunityModel
}) => {
  const t = useTranslations().app
  const events = topicCommunity?.events ?? []

  if (events.length === 0) {
    return (
      <Column gap="1rem">
        <Title.H4>{t.topicCommunityPage.tabs.events}</Title.H4>
        <Text.Medium color="var(--palette-blue-600)">
          {t.topicCommunityPage.noEvents}
        </Text.Medium>
      </Column>
    )
  }

  return (
    <Column gap="1.5rem">
      <Title.H4>{t.topicCommunityPage.tabs.events}</Title.H4>
      {events.map((event) => {
        return (
          <EventCard
            key={event.uuid}
            title={event.title}
            start={event.start}
            end={event.end}
            to={pages.event(event.slug)}
          />
        )
      })}
    </Column>
  )
}
